// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qXpu","title":"styles_title__2if1O"};